import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ShopState {
    currency: "KZT";
}

const initialState: ShopState = {
    currency: "KZT",
};

export const shopReducer = createSlice({
    name: "shop",
    initialState,
    reducers: {
        setCurrency(state, action: PayloadAction<"KZT">) {
            state.currency = action.payload;
        },
    },
});

export const { setCurrency } = shopReducer.actions;
export default shopReducer.reducer;
